import { SxProps } from '@mui/material';
import { PaperProps } from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import { blueGrey, grey, red } from '@mui/material/colors';

const buttonStyles = {
  padding: '8px 20px',
  textTransform: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  color: 'white',
};

const dialogStyles: {
  dialog: PaperProps;
  dialogPaper: SxProps<Theme>;
  dialogCloseButton: SxProps<Theme>;
  dialogTitle: SxProps<Theme>;
  dialogContent: SxProps<Theme>;
  dialogContentText: SxProps<Theme>;
  dialogActions: SxProps<Theme>;
  dialogContentForm: SxProps<Theme>;
  dialogContentFormTextField: SxProps<Theme>;
  gridStyles: SxProps<Theme>;
  cancelButtonStyles: SxProps<Theme>;
  confirmButtonStyles: SxProps<Theme>;
  warningTypographyStyles: SxProps<Theme>;
  warningIconStyles: SxProps<Theme>;
  buttonIconSpacing: SxProps<Theme>;
  reservationInfoStyles: SxProps<Theme>;
  readOnlyTextFieldStyles: SxProps<Theme>;
} = {
  dialog: {
    style: {
      minWidth: 600,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)',
      borderRadius: '12px',
    },
  },
  dialogPaper: {
    '& .MuiDialog-paper': {
      maxWidth: 600,
      width: '100%',
    },
  },
  dialogCloseButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: 'white',
    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
  },
  dialogTitle: {
    color: 'white',
    fontSize: '1.2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    padding: '15px',
  },
  dialogContent: {
    padding: '10px',
    textAlign: 'center',
    fontSize: '1rem',
    color: grey[900],
  },
  dialogContentText: {
    color: grey[900],
    fontWeight: 'bold',
    marginTop: 4,
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '30px',
    padding: '16px',
  },
  dialogContentForm: {
    paddingBottom: 0,
  },
  dialogContentFormTextField: {
    marginTop: 1,
    '& .MuiInputBase-inputMultiline': {
      fontSize: '1rem',
      lineHeight: 1.5,
      resize: 'none',
    },
  },
  gridStyles: {
    display: 'grid',
    gap: '12px 30px',
    textAlign: 'left',
    width: 'fit-content',
    margin: '16px auto 0',
  },
  cancelButtonStyles: {
    ...buttonStyles,
    backgroundColor: blueGrey[500],
    '&:hover': {
      backgroundColor: blueGrey[700],
    },
  },
  confirmButtonStyles: {
    ...buttonStyles,
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  warningTypographyStyles: {
    flex: '1 1 100%',
    alignItems: 'center',
    fontWeight: 'bold',
    paddingBottom: 2,
    color: red[500],
  },
  warningIconStyles: {
    verticalAlign: 'middle',
    marginRight: 1,
    color: red[500],
  },
  buttonIconSpacing: {
    marginRight: '8px',
  },
  reservationInfoStyles: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    gap: 3,
    mb: 1,
    fontWeight: 500,
  },
  readOnlyTextFieldStyles: {
    '& .MuiInputBase-root': {
      backgroundColor: grey[100],
    },
    '& .MuiInputBase-input': {
      color: grey[700],
      cursor: 'default',
    },
    '& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-focused': {
      color: grey[600],
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: grey[300],
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: grey[300],
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: grey[300],
      borderWidth: 1,
    },
  },
};

export default dialogStyles;
